var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExclamation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/Important/16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4185 6.91625L17.2485 9.00125L15.4185 11.0863L15.6735 13.8462L12.966 14.4613L11.5485 16.8463L8.99853 15.7513L6.44853 16.8538L5.03103 14.4688L2.32354 13.8538L2.57854 11.0863L0.748535 9.00125L2.57854 6.90875L2.32354 4.14875L5.03103 3.54125L6.44853 1.15625L8.99853 2.25125L11.5485 1.15625L12.966 3.54125L15.6735 4.15625L15.4185 6.91625ZM8.99213 11.1384C8.43053 11.1384 7.9857 11.5596 7.9857 12.1448C7.9857 12.73 8.43053 13.1634 8.99213 13.1634C9.56588 13.1634 10.0107 12.73 10.0107 12.1448C10.0107 11.5596 9.56588 11.1384 8.99213 11.1384ZM8.30683 4.7531C8.3487 4.73518 8.39376 4.72591 8.4393 4.72586H9.55643C9.60202 4.72582 9.64716 4.73502 9.68911 4.7529C9.73105 4.77078 9.76894 4.79698 9.80048 4.82991C9.83202 4.86284 9.85657 4.90182 9.87263 4.94449C9.88869 4.98717 9.89593 5.03266 9.89393 5.07821L9.68805 9.80321C9.68422 9.89013 9.64698 9.9722 9.5841 10.0323C9.52122 10.0924 9.43755 10.1259 9.35055 10.1259H8.64653C8.55953 10.1259 8.47586 10.0924 8.41298 10.0323C8.35009 9.9722 8.31285 9.89013 8.30903 9.80321L8.10248 5.07821C8.10047 5.03272 8.1077 4.98728 8.12372 4.94465C8.13973 4.90202 8.16422 4.86307 8.19569 4.83015C8.22716 4.79723 8.26496 4.77102 8.30683 4.7531Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamation);
export default __webpack_public_path__ + "static/media/exclamation.e7269dded06ffac81420712029dfa89a.svg";
export { ForwardRef as ReactComponent };